import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { auth, googleProvider } from './firebase';
import { signInWithPopup } from "firebase/auth";
import { getApiUrl } from './config/api';

// --- USER LOGIN ---
export function UserLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            console.log('Login API Request:', { email, password });
            const res = await fetch(getApiUrl('LOGIN'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });
            console.log('Login API Response Status:', res.status);
            const data = await res.json();
            console.log('Login API Response Data:', data);
            if (res.ok && data.success) {
                if (data.token) localStorage.setItem('userToken', data.token);
                if (data.user) localStorage.setItem('userInfo', JSON.stringify(data.user));
                navigate('/');
            } else {
                setError(data.message || 'Login failed');
            }
        } catch (err) {
            console.error('Login API Error:', err);
            setError('Network error');
        }
        setLoading(false);
    };

    // Firebase Google Sign-In handler
    const handleFirebaseGoogleSignIn = async () => {
        setError('');
        setSuccess('');
        try {
            const result = await signInWithPopup(auth, googleProvider);
            console.log('Firebase Google User:', result.user);
            if (result.user && result.user.email) {
                setSuccess('Google Sign-In successful!');
                setTimeout(() => {
                    navigate('/');
                }, 1200);
            } else {
                setError('Google Sign-In failed');
            }
        } catch (error) {
            console.error('Firebase Google Sign-In Error:', error);
            setError('Google Sign-In failed');
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center">
            <div className="flex items-center justify-center mb-4">
                <Link to="/">
                    <img src="/logo.jpg" alt="Logo" className="w-32 h-16 object-contain mr-3 cursor-pointer" />
                </Link>
                <div>
                    <h1 className="text-2xl font-bold text-yellow-600">AHMEDABAD POST</h1>
                    <p className="text-gray-600 text-base">User Login</p>
                </div>
            </div>
            <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-xl font-bold text-center text-gray-800 mb-6">Sign In</h2>
                <form onSubmit={handleLogin}>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                            placeholder="you@amdavadpost.com"
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                            placeholder="******************"
                            required
                        />
                    </div>
                    {error && <div className="text-red-600 text-sm mb-4">{error}</div>}
                    {success && <div className="text-green-600 text-sm mb-4">{success}</div>}
                    <button
                        type="submit"
                        className="w-full bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg transition-colors duration-300"
                        disabled={loading}
                    >
                        {loading ? 'Signing In...' : 'Sign In'}
                    </button>
                </form>
                {/* <div className="mt-4 w-full flex flex-col items-center">
                    <button
                        type="button"
                        onClick={handleFirebaseGoogleSignIn}
                        className="w-full flex items-center justify-center gap-2 bg-white border border-[#4285F4] shadow-md hover:shadow-lg hover:bg-[#f7faff] text-[#4285F4] font-semibold py-2 px-4 rounded-lg transition-all duration-200 mt-2"
                        style={{
                            boxShadow: '0 2px 8px rgba(66,133,244,0.12)',
                            fontSize: '1rem',
                            letterSpacing: '0.02em'
                        }}
                    >
                        <img
                            src="https://img.favpng.com/2/20/9/google-logo-google-search-search-engine-optimization-google-images-png-favpng-mrjKbWHacks0WiKXmVVZugyri.jpg"
                            alt="Google"
                            className="w-5 h-5"
                            style={{ marginRight: '8px' }}
                        />
                        <span>Continue with Google</span>
                    </button>
                </div> */}
                <div className="mt-4 text-center">
                    <span className="text-gray-600 text-sm">Not a user? </span>
                    <Link to="/signup" className="text-blue-600 hover:underline font-semibold text-sm">
                        Sign Up
                    </Link>
                </div>
            </div>
        </div>
    );
}

// --- USER SIGNUP ---
export function UserSignup() {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleSignup = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');
        try {
            console.log('Signup API Request:', { username, email, password });
            const res = await fetch(getApiUrl('SIGNUP'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, email, password })
            });
            console.log('Signup API Response Status:', res.status);
            const data = await res.json();
            console.log('Signup API Response Data:', data);
            if (res.ok && data.success) {
                setSuccess('Signup successful! Please login.');
                setTimeout(() => navigate('/login'), 1500);
            } else {
                setError(data.message || 'Signup failed');
            }
        } catch (err) {
            console.error('Signup API Error:', err);
            setError('Network error');
        }
        setLoading(false);
    };

    // Firebase Google Sign-Up handler
    const handleFirebaseGoogleSignUp = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            console.log('Firebase Google User:', result.user);
            // If user is already registered, redirect to home
            if (result.user && result.user.email) {
                // Optionally, you can check with your backend if user exists
                navigate('/');
            }
        } catch (error) {
            console.error('Firebase Google Sign-Up Error:', error);
            setError('Google Sign-Up failed');
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center">
            <div className="flex items-center justify-center mb-4">
                <Link to="/">
                    <img src="/logo.jpg" alt="Logo" className="w-32 h-16 object-contain mr-3 cursor-pointer" />
                </Link>
                <div>
                    <h1 className="text-2xl font-bold text-yellow-600">AHMEDABAD POST</h1>
                    <p className="text-gray-600 text-base">User Signup</p>
                </div>
            </div>
            <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-xl font-bold text-center text-gray-800 mb-6">Sign Up</h2>
                <form onSubmit={handleSignup}>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
                            Username
                        </label>
                        <input
                            id="username"
                            type="text"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                            placeholder="Your name"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                            placeholder="you@amdavadpost.com"
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500"
                            placeholder="******************"
                            required
                        />
                    </div>
                    {error && <div className="text-red-600 text-sm mb-4">{error}</div>}
                    {success && <div className="text-green-600 text-sm mb-4">{success}</div>}
                    <button
                        type="submit"
                        className="w-full bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg transition-colors duration-300"
                        disabled={loading}
                    >
                        {loading ? 'Signing Up...' : 'Sign Up'}
                    </button>
                </form>
                {/* <div className="mt-4 w-full flex flex-col items-center">
                    <button
                        type="button"
                        onClick={handleFirebaseGoogleSignUp}
                        className="w-full flex items-center justify-center gap-2 bg-white border border-[#4285F4] shadow-md hover:shadow-lg hover:bg-[#f7faff] text-[#4285F4] font-semibold py-2 px-4 rounded-lg transition-all duration-200 mt-2"
                        style={{
                            boxShadow: '0 2px 8px rgba(66,133,244,0.12)',
                            fontSize: '1rem',
                            letterSpacing: '0.02em'
                        }}
                    >
                        <img
                            src="https://img.favpng.com/2/20/9/google-logo-google-search-search-engine-optimization-google-images-png-favpng-mrjKbWHacks0WiKXmVVZugyri.jpg"
                            alt="Google"
                            className="w-5 h-5"
                            style={{ marginRight: '8px' }}
                        />
                        <span>Continue with Google</span>
                    </button>
                </div> */}
                <div className="mt-4 text-center">
                    <span className="text-gray-600 text-sm">Already a user? </span>
                    <Link to="/login" className="text-blue-600 hover:underline font-semibold text-sm">
                        Sign In
                    </Link>
                </div>
            </div>
        </div>
    );
}

